import { Box } from "@mui/material";
import React from "react";
import "../Skills/Skills.css";

import html from "../Images/HTML.png"
import css from "../Images/CSS.png"
import js from "../Images/JS.png"

import node from "../Images/node.png"
import react from "../Images/React.png"
import redux from "../Images/Redux.png"
import mongodb from "../Images/MongoDb.png"

import express from "../Images/Express.png"
import framer from "../Images/FramerMotion.png"
import github from "../Images/Github.png"
import router from "../Images/ReactRouter.png"


export const Skills = () => {

    function parallax(e){
        this.querySelectorAll(".layer").forEach(layer => {
            const speed = layer.getAttribute("dataspeed")           
            const x = (window.innerWidth - e.pageX*speed)/100
            const y = (window.innerHeight - e.pageY*speed)/100

            layer.style.transform = `translate(${x}px) translate(${y}px)`
        })
    }

    React.useEffect(() => {
        document.addEventListener("mousemove", parallax);
    })

    return (
        <>
        <Box className="skills" id="Skills">
            <img className="layer" style={{top:0, left:0, width:'8vw', marginLeft:"2vw", marginTop:"4vh", zIndex:0}} alt="skills" dataspeed="-5" src={html}/>
            <img className="layer" style={{top:0, width:'5vw', marginLeft:"10vw", marginTop:"10vh", zIndex:0}} alt="skills" dataspeed="05" src={css}/>
            <img className="layer" style={{top:0, width:"6vw", right:0, marginRight:"18vw", marginTop:"7vh", zIndex:0}} alt="skills" dataspeed="02" src={js}/>

            <img className="layer" style={{left:0,width:"10vw", marginLeft:"15vw", zIndex:0}} alt="skills" dataspeed="06" src={node}/>
            <img className="layer" style={{left:0, marginLeft:"35vw", marginTop:"-14vh", zIndex:0}} alt="skills" dataspeed="08" src={react}/>
            <img className="layer" style={{left:0, width:"8vw", marginLeft:"68vw", marginTop:"10vh", zIndex:1}} alt="skills" dataspeed="06" src={redux}/>
            <img className="layer" style={{left:0, width:"13vw", marginLeft:"70vw", marginTop:"-10vh", zIndex:1}} alt="skills" dataspeed="-7" src={mongodb}/>

            <img className="layer" style={{bottom:0, left:0, width:"20vw", marginLeft:"8vw", marginBottom:"4vh", zIndex:0}} alt="skills" dataspeed="04" src={express}/>
            <img className="layer" style={{bottom:0, left:0, width:"7vw", marginLeft:"30vw", marginBottom:"8vh", zIndex:1}} alt="skills" dataspeed="-5" src={framer}/>
            <img className="layer" style={{bottom:0, left:0, width:"15vw", marginLeft:"60vw", marginBottom:"4vh", zIndex:0}} alt="skills" dataspeed="5" src={github}/>
            <img className="layer" style={{bottom:0, right:0, width:"10vw", marginRight:"15vw", marginBottom:"8vh", zIndex:0}} alt="skills" dataspeed="-6" src={router}/>
            {/* <img className="layer" style={{top:0, left:0, marginLeft:"2vw", marginTop:"4vh", zIndex:0}} alt="skills" dataspeed="-7" src="https://mui.com/static/logo.png"/> */}
            {/* <img className="layer" style={{top:0, left:0, marginLeft:"2vw", marginTop:"4vh", zIndex:0}} alt="skills" dataspeed="05" src="http://assets.stickpng.com/images/60107bff99eef2000443c2eb.png"/> */}
            <h1>Skills</h1>
        </Box>
        </>
    )
}